import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_COUPON_TYPE,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  PAYOFF_PARTICIPATION,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_UNDERLYING_ASSETS,
  PAYOFF_COUPON_FLOATING_PERIODS,
  PAYOFF_COUPON_OBVS_FREQUENCY,
  PAYOFF_COUPON_MEMORY,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_CALLABILITY_AMOUNT,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const CHOOSER_SETTINGS = {
  id: ProductTypeEnum.CHOOSER,
  label: 'Chooser',
  effects: [
    {
      formControlNames: [
        PAYOFF_PARTICIPATION,
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_FLOATING_PERIODS,
        PAYOFF_COUPON_OBVS_FREQUENCY,
        PAYOFF_COUPON_MEMORY,
        PAYOFF_COUPON_CONVERSION,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['NONE'],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.LOWEST_FX_PERFORMANCE],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH'],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.WORST_OF],
      options: [PERFORMANCE_TYPE_KEYS.WORST_OF, PERFORMANCE_TYPE_KEYS.BEST_OF],
      readOnly: false,
    },
  ],
  concatFieldRules: [
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      options: [
        {
          id: 'ISSUER_CALL',
          effects: [
            {
              formControlNames: [PAYOFF_CALLABILITY_AMOUNT],
              hidden: false,
              readOnly: true,
              selectValues: [
                {
                  value: '100%',
                  minValue: null,
                  maxValue: null,
                  indicativeValue: null,
                },
              ],
            },
            {
              formControlNames: [PAYOFF_CALLABILITY_AMOUNT_TYPE],
              selectValues: ['FLAT'],
              hidden: false,
              readOnly: true,
            },
          ],
        },
      ],
    },
  ],
};
